import React, { useEffect, useRef, useState } from 'react';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { useTheme } from '../../theme-context';
import { useSpeech } from '../../utils/speach-settings';
import { useSiteWideSpeechStop } from '../../utils/audio-settings';
import Button from '../button';
import Switch from '../switch';
import Input from '../input';
import SelectCheckbox from '../select-checkbox';
import { CompetitorsType } from '../../utils/constants/competitors-type';

interface IAiMessages {
    text: string;
    files?: { name: string; url: string }[] | null;
    isNew?: boolean;
    data?: any;
    showActions?: boolean;
    considerDarkMode?: boolean;
    isTyping: boolean;
    uploadedFiles?: any;
    templateFiles?: any;
    containerStyle?: any;
    models?: any;
    selectedModels?: any;
    selectedPrompts?: any;
    selectedCompetitors?: any;
    addedPrompts?: any;
    addedCompetitors?: any;
    typingMode?: any;
    itemsPerTick?: number;
    typingDelayMs?: number;
    pricingLoading?: boolean;
    handleFileChange?: (e: any, section: string) => void;
    removeFile?: (section: string, index: number) => void;
    onClickOptions?: (option: any, stage?: string, type?: string) => void;
    setIsTyping: (val: boolean) => void;
    onClickAction?: (action: string, id: string) => void;
    onClickLinks?: (type: string) => void;
    onClickSendFiles?: (files: any) => void;
    onClickSave?: (stage: string) => void;
    addNewItem?: (value: any, type: string, itemType?: any) => void;
    onClickPricing?: (type: string, data?: any) => void;
}

const AiMessages = ({
    text,
    files,
    isNew = false,
    typingMode = 'line',
    isTyping,
    setIsTyping,
    data,
    showActions,
    considerDarkMode,
    uploadedFiles,
    templateFiles,
    containerStyle,
    selectedCompetitors,
    selectedPrompts,
    selectedModels,
    models,
    addedPrompts,
    addedCompetitors,
    itemsPerTick = 2,
    typingDelayMs = 20,
    pricingLoading,
    handleFileChange,
    removeFile,
    onClickOptions,
    onClickAction,
    onClickLinks,
    onClickSave,
    addNewItem,
    onClickPricing
}: IAiMessages) => {
    const { theme } = useTheme();
    const cancelRef = useRef(false);
    const [previews, setPreviews] = useState<{ name: string; url: string; type: string; preview?: any[][] }[]>([]);
    const [displayedText, setDisplayedText] = useState(isNew ? '' : text);
    // const [isRichText, setIsRichText] = useState<boolean>(false);
    const [newPrompt, setNewPrompt] = useState<any>();
    const [newBrand, setNewBrand] = useState<any>();
    const [newType, setNewType] = useState<any>();
    const { speak, stop, isSpeaking } = useSpeech();
    // const isHTML = (input: string) => /<\/?[a-z][\s\S]*>/i.test(input);
    const filesTemplateArray = data?.stage === 'upload_template_files' ? data?.files && Object.keys(data?.files) : ['Bank System', 'POS']
    useSiteWideSpeechStop();

    const tokenizeText = (s: string, mode: any) => {
        if (mode === 'word') return s.match(/\S+\s*/g) || [];
        if (mode === 'line') return s.split(/(\n)/).map(x => x);
        return s.split('');
    };
    const isHtmlText = /<\/?[a-z][\s\S]*>/i.test(text || '');

    useEffect(() => {
        if (!isNew) return;

        const mode = typingMode || 'char';
        const delay = typingDelayMs ?? (mode === 'char' ? 16 : 40);
        const perTick = Math.max(1, itemsPerTick ?? (mode === 'char' ? 3 : 1));

        cancelRef.current = false;
        setIsTyping(true);
        setDisplayedText('');

        const splitHTML = (html: string) => (html?.match(/(<[^>]+>|[^<]+)/g) || []);

        const raw = isHtmlText ? splitHTML(text) : [text];
        const tokens: string[] = [];
        raw.forEach((part) => {
            if (part.startsWith('<')) tokens.push(part);
            else tokens.push(...tokenizeText(part, mode));
        });

        let i = 0;
        let out = '';
        const tick = () => {
            if (cancelRef.current || i >= tokens.length) {
                setIsTyping(false);
                return;
            }
            let emitted = 0;
            while (i < tokens.length && emitted < perTick) {
                out += tokens[i++];
                emitted++;
            }
            setDisplayedText(out);
            setTimeout(tick, delay);
        };

        tick();
        return () => { cancelRef.current = true; };
    }, [isNew, text, typingMode, itemsPerTick, typingDelayMs, isHtmlText]);


    // useEffect(() => {
    //     if (!isNew) return;

    //     cancelRef.current = false;
    //     setIsTyping(true);
    //     setDisplayedText('');
    //     setIsRichText(isHTML(text));

    //     const splitHTML = (html: string) => {
    //         const regex = /(<[^>]+>|[^<]+)/g;
    //         return html?.match(regex) || [];
    //     };

    //     const chunks = isHTML(text) ? splitHTML(text) : [text];
    //     let fullOutput = '';
    //     let pendingTags = '';
    //     let chunkIndex = 0;
    //     let charIndex = 0;

    //     const CHARS_PER_TICK = 2;
    //     const DELAY_MS = 20;

    //     const typeNext = () => {
    //         if (cancelRef.current || chunkIndex >= chunks.length) {
    //             setIsTyping(false);
    //             return;
    //         }

    //         const currentChunk = chunks[chunkIndex];

    //         if (currentChunk?.startsWith('<')) {
    //             pendingTags += currentChunk;
    //             chunkIndex++;
    //             setTimeout(typeNext, 0);
    //         } else {
    //             if (charIndex < currentChunk?.length) {
    //                 if (pendingTags) {
    //                     fullOutput += pendingTags;
    //                     pendingTags = '';
    //                 }

    //                 // ⬇️ Append multiple characters per tick
    //                 const nextSlice = currentChunk.slice(charIndex, charIndex + CHARS_PER_TICK);
    //                 fullOutput += nextSlice;
    //                 charIndex += CHARS_PER_TICK;

    //                 setDisplayedText(fullOutput);
    //                 setTimeout(typeNext, DELAY_MS);
    //             } else {
    //                 chunkIndex++;
    //                 charIndex = 0;
    //                 setTimeout(typeNext, 0);
    //             }
    //         }
    //     };

    //     typeNext();

    //     return () => {
    //         cancelRef.current = true;
    //     };
    // }, [isNew, text]);


    useEffect(() => {
        if (data?.stage === 'upload_template_files') return;
        if (!files || files?.length === 0) return;

        const loadPreviews = async () => {
            if (files && files?.length > 0) {
                const loaded = await Promise.all(
                    files?.map(async (file) => {
                        const fileName = file?.url?.split('/').pop() || '';
                        const fileNameLower = fileName.toLowerCase();

                        const isCsv = fileNameLower.endsWith('.csv');
                        const isExcel = fileNameLower.endsWith('.xls') || fileNameLower.endsWith('.xlsx');
                        const isPdf = fileNameLower.endsWith('.pdf');
                        let preview: any[][] | undefined;

                        try {
                            const res = await fetch(file.url);

                            if (isCsv) {
                                const text = await res.text();
                                preview = Papa.parse(text, { preview: 5 }).data as any[][];
                            } else if (isExcel) {
                                const buffer = await res.arrayBuffer();
                                const wb = XLSX.read(buffer, { type: 'array' });
                                const sheet = wb.Sheets[wb.SheetNames[0]];
                                preview = XLSX.utils.sheet_to_json(sheet, { header: 1 }) as any[][];
                            }
                        } catch (err) {
                            console.error('Preview fetch failed:', err);
                        }

                        return {
                            name: file.name,
                            url: file.url,
                            type: isCsv ? 'csv' : isExcel ? 'excel' : isPdf ? 'pdf' : 'other',
                            preview,
                        };
                    })
                );

                setPreviews(loaded);
            }
        };

        loadPreviews();
    }, [files]);

    const getPlainText = (html: string): string => {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const plainText = temp.textContent || temp.innerText || '';

        if (!data?.options || data?.options?.length === 0) return plainText;

        const optionsText = data?.options?.map((opt: any) => opt?.key ? `${opt?.key}) ${opt?.value}` : ` ${opt?.value}`).join('\n');

        return `${plainText}\n\nOptions:\n${optionsText}`;
    };

    const formatTemplateFilesName = (name: string) => {
        const namesToFormat: any = {
            'bank': 'Bank Statement',
            'pos': 'POS Sytem Export',
            'psp': 'PSP Report'
        }
        return namesToFormat?.[name] || name
    }

    const handleClickSpeaking = () => {
        const plain = getPlainText(text);
        if (isSpeaking) {
            stop();
        } else {
            speak(plain, { lang: 'en-US' });
        }
    };

    const onChangePrompt = (value: any) => {
        setNewPrompt(value)
    }

    const onChangeBrand = (value: any, type?: string) => {
        if (type === 'brand') {
            setNewBrand(value)
        } else {
            setNewType(value?.value)
        }
    }

    const onClickAddOptions = (value: any, type: string, data?: any) => {
        setNewBrand(undefined)
        setNewType(undefined)
        setNewPrompt(undefined)
        addNewItem?.(value, type, data)
    }

    const getYearlyDiscountPercent = (options: any) => {
        const monthly = options?.find((o: any) => o?.plan === 'month');
        const yearly = options?.find((o: any) => o?.plan === 'year');

        if (!monthly || !yearly) return 0;

        const monthlyTotal = Number(monthly?.value || monthly?.total);
        const yearlyTotal = Number(yearly?.value || yearly?.total);

        if (!isFinite(monthlyTotal) || !isFinite(yearlyTotal) || monthlyTotal <= 0) return 0;

        const payMonthlyForYear = monthlyTotal * 12;
        const raw = (1 - (yearlyTotal / payMonthlyForYear)) * 100;

        return Math.max(0, Math.min(100, Math.floor(raw)));
    };

    return (
        <div className={`!rounded-xl m-2 py-2 px-3 bg-white ${considerDarkMode ? 'dark:!bg-[#3a3a3a]' : ''} ${containerStyle} max-w-[90%]`}>
            <div className={`mb-2 whitespace-pre-wrap break-words ${considerDarkMode ? 'dark:text-primary-dark' : ''}`}>
                {isHtmlText ? (
                    <div dangerouslySetInnerHTML={{ __html: isTyping ? displayedText : text }} />
                ) : (
                    <p>{isTyping ? displayedText : text}</p>
                )}
            </div>

            {/* {isTyping && <span className='animate-pulse'>|</span>} */}

            {(data?.details && !isTyping) && (
                <Button
                    label={data?.details?.title}
                    className={`btn-primary-text-underline ${considerDarkMode ? 'dark:text-white' : ''}`}
                    onClickButton={() => onClickLinks?.(data?.details?.type)}
                />
            )}

            {(!isTyping && previews?.length > 0 && data?.stage !== 'upload_template_files') && (
                <div className='flex flex-wrap gap-2'>
                    {previews.map((file, idx) => {
                        const isImage = file.name.match(/\.(jpg|jpeg|png|gif|webp)$/i);

                        return (
                            <a
                                key={idx}
                                href={file.url}
                                download={file.name}
                                target='_blank'
                                rel='noopener noreferrer'
                                className={`relative border border-gray-300 rounded p-2 w-fit max-w-[300px] bg-gray-100 !text-white ${considerDarkMode ? 'dark:bg-gray-400 dark:text-black' : ''
                                    } hover:shadow-lg transition-all`}
                            >
                                {isImage ? (
                                    <img src={file.url} alt={file.name} className='w-24 h-24 object-cover rounded' />
                                ) : file.type === 'pdf' ? (
                                    <iframe src={file.url} title={file.name} className='w-48 h-32 border rounded' />
                                ) : file.preview ? (
                                    <div className='overflow-x-auto max-h-32 mb-2 border'>
                                        <table className='text-xs text-left border-collapse w-full'>
                                            <tbody>
                                                {file.preview.map((row, rowIdx) => (
                                                    <tr key={rowIdx}>
                                                        {row.map((cell, colIdx) => (
                                                            <td
                                                                key={colIdx}
                                                                className='border px-1 py-0.5 whitespace-nowrap text-black'
                                                            >
                                                                {cell}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : null}
                                <div
                                    className={`bg-[#252B37f0] text-white ${considerDarkMode ? 'dark:bg-gray-200 dark:text-black' : ''
                                        } text-center text-xs rounded-lg p-2 mt-1 truncate max-w-[250px]`}
                                >
                                    {file.name}
                                </div>
                            </a>
                        );
                    })}
                </div>
            )}
            {(!isTyping && filesTemplateArray && data?.stage === 'upload_template_files') && (
                <div className='flex flex-col gap-4'>
                    {filesTemplateArray?.map((item: any, index: number) => {
                        const isLastSingle = index === filesTemplateArray?.length - 1 && filesTemplateArray?.length % 2 !== 0;
                        const templateFilesForThis = templateFiles && templateFiles?.length > 0 && templateFiles?.filter((temp: any) => temp?.type === item)
                        if (isLastSingle) {
                            return (
                                <div key={index} className='w-full'>
                                    <div className='border rounded-md p-4 w-full h-full flex flex-col'>
                                        <h2 className='font-medium mb-2 dark:text-primary-dark'>{formatTemplateFilesName(item)}</h2>
                                        <div className='border-dashed border-2 border-gray-300 rounded-md cursor-pointer h-full flex flex-col justify-between p-4 relative'>
                                            {(uploadedFiles?.[item]?.length > 0 && !(templateFilesForThis && templateFilesForThis?.length > 0)) && (
                                                <div className='space-y-2 absolute top-0 bottom-0 right-0 left-0 bg-blue-900 flex flex-col justify-center rounded-md'>
                                                    {uploadedFiles?.[item].map((file: any, idx: number) => (
                                                        <div
                                                            key={idx}
                                                            className='flex justify-center items-center bg-blue-900 text-white text-sm rounded px-4 py-2'
                                                        >
                                                            <span className='truncate max-w-[80%]'>{file.name}</span>
                                                            <button onClick={() => removeFile?.(item, idx)} className='ml-2 hover:opacity-70'>
                                                                <img src={'/assets/chat/delete-icon.svg'} className='object-contain w-[20px]' />
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            {(templateFilesForThis && templateFilesForThis?.length > 0) && (
                                                <div className='space-y-2 absolute top-0 bottom-0 right-0 left-0 bg-blue-900 flex flex-col justify-center rounded-md'>
                                                    {templateFilesForThis?.map((file: any, idx: number) => (
                                                        <div
                                                            key={idx}
                                                            className='flex justify-center items-center bg-blue-900 text-white text-sm rounded px-4 py-2'
                                                        >
                                                            <span className='truncate max-w-[80%]'>{file?.name}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            <input
                                                type='file'
                                                multiple
                                                className='hidden'
                                                accept='.csv, .xls, .xlsx, .xml, .pdf, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/xml, application/xml, application/pdf'
                                                id={`file-${item}`}
                                                onChange={(e) => handleFileChange?.(e, item)}
                                            />
                                            <label htmlFor={`file-${item}`} className='cursor-pointer block'>
                                                <div className='mb-2 flex justify-center'>
                                                    <img
                                                        src={theme === 'dark'
                                                            ? '/assets/chat/upload-files-white.svg'
                                                            : '/assets/chat/upload-files.svg'}
                                                        className='object-contain w-[40px]'
                                                    />
                                                </div>
                                                <p className='text-primary-light dark:text-primary-dark text-center'>
                                                    Drop files here or click to browse
                                                </p>
                                                <p className='text-sm text-primary-light dark:text-primary-dark text-center'>
                                                    Supports .csv, .xlsx, .xml, .pdf
                                                </p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            );
                        }

                        if (index % 2 === 0) {
                            const fieldOne = item;
                            const fieldTwo = filesTemplateArray[index + 1];

                            return (
                                <div key={index} className='flex flex-col sm:flex-row gap-4'>
                                    {[fieldOne, fieldTwo].map(
                                        (field, i) =>
                                            field && (
                                                <div key={i} className='w-full sm:w-1/2'>
                                                    <div className='border rounded-md p-4 w-full h-full flex flex-col'>
                                                        <h2 className='font-medium mb-2 dark:text-primary-dark'>{formatTemplateFilesName(field)}</h2>
                                                        <div className='border-dashed border-2 border-gray-300 rounded-md cursor-pointer h-full flex flex-col justify-between p-4 relative'>
                                                            {(uploadedFiles?.[field] && uploadedFiles?.[field]?.length > 0 && !(templateFilesForThis && templateFilesForThis?.length > 0)) && (
                                                                <div className='space-y-2 absolute top-0 bottom-0 right-0 left-0 bg-blue-900 flex flex-col justify-center'>
                                                                    {uploadedFiles?.[field].map((file: any, idx: number) => (
                                                                        <div
                                                                            key={idx}
                                                                            className='flex justify-center items-center bg-blue-900 text-white text-sm rounded px-4 py-2 !rounded-md'
                                                                        >
                                                                            <span className='truncate max-w-[80%]'>{file.name}</span>
                                                                            <button onClick={() => removeFile?.(field, idx)} className='ml-2 hover:opacity-70'>
                                                                                <img src={'/assets/chat/delete-icon.svg'} className='object-contain w-[20px]' />
                                                                            </button>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            {(templateFilesForThis && templateFilesForThis?.length > 0) && (
                                                                <div className='space-y-2 absolute top-0 bottom-0 right-0 left-0 bg-blue-900 flex flex-col justify-center rounded-md'>
                                                                    {templateFilesForThis?.map((file: any, idx: number) => (
                                                                        <div
                                                                            key={idx}
                                                                            className='flex justify-center items-center bg-blue-900 text-white text-sm rounded px-4 py-2'
                                                                        >
                                                                            <span className='truncate max-w-[80%]'>{file?.name}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            <input
                                                                type='file'
                                                                multiple
                                                                accept='.csv, .xls, .xlsx, .xml, .pdf, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/xml, application/xml, application/pdf'
                                                                className='hidden'
                                                                id={`file-${field}`}
                                                                onChange={(e) => handleFileChange?.(e, field)}
                                                            />
                                                            <label htmlFor={`file-${field}`} className='cursor-pointer block'>
                                                                <div className='mb-2 flex justify-center'>
                                                                    <img
                                                                        src={theme === 'dark'
                                                                            ? '/assets/chat/upload-files-white.svg'
                                                                            : '/assets/chat/upload-files.svg'}
                                                                        className='object-contain w-[40px]'
                                                                    />
                                                                </div>
                                                                <p className='text-primary-light dark:text-primary-dark text-center'>
                                                                    Drop files here or click to browse
                                                                </p>
                                                                <p className='text-sm text-primary-light dark:text-primary-dark text-center'>
                                                                    Supports .csv, .xlsx, .xml, .pdf
                                                                </p>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                    )}
                                </div>
                            );
                        }
                        return null;
                    })}
                    {/* {readyMessage && <p className='dark:text-primary-dark mb-2 whitespace-pre-wrap break-words'>Are you finished with the file upload?</p>} */}
                </div>
            )}
            {(data?.options?.length > 0 && !isTyping) &&
                <div className='flex flex-col'>
                    {data?.stage === 'prompt_suggestion' &&
                        <>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                {[...data?.options || [], ...addedPrompts || []]?.map((item: any, idx: number) => {
                                    const findIfSelected = selectedPrompts && selectedPrompts?.length > 0 && selectedPrompts?.find((prompt: any) => prompt?.text === item?.value)
                                    return (
                                        <div key={idx}
                                            onClick={() => isNew && onClickOptions?.(item, data?.stage)}
                                            className='flex md:flex-row items-center justify-between cursor-pointer hover:opacity-80 px-4 py-2 my-1 bg-white dark:bg-black rounded-lg'>
                                            <p className='dark:text-primary-dark text-md max-w-[85%]'>{item?.value}</p>
                                            <input
                                                type='checkbox'
                                                checked={!!findIfSelected}
                                                className='accent-green-600 w-[20px] h-[20px]'
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='my-3 flex flex-row item-center'>
                                <Input
                                    placeholder={'New Prompt'}
                                    inputValue={newPrompt}
                                    containerStyle='min-w-[50%]'
                                    showValue={true}
                                    disabled={!isNew}
                                    onChangeInput={onChangePrompt}
                                />
                                <Button
                                    label={'Add Prompt'}
                                    className={`btn-border-rounded ml-4 mb-4 ${newPrompt && isNew ? '' : 'opacity-50'}`}
                                    onClickButton={() => (newPrompt && isNew) && onClickAddOptions?.(newPrompt, 'prompts')}
                                />
                            </div>
                            <div className='my-4 flex flex-row justify-end'>
                                <Button
                                    label={'Save'}
                                    className={`${selectedPrompts?.length > 0 && isNew ? 'btn-primary-rounded-less !bg-[#00330F]' : 'btn-primary-rounded-less-disable opacity-70'} `}
                                    onClickButton={() => (selectedPrompts?.length > 0 && isNew) && onClickSave?.(data?.stage)}
                                />
                            </div>
                        </>
                    }
                </div>
            }
            {(data?.options?.length > 0 && !isTyping) &&
                <div className='flex flex-col'>
                    {data?.stage === 'select_competitor_stage' &&
                        <>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                                {[...data?.options || [], ...addedCompetitors || []]?.map((item: any, idx: number) => {
                                    const findIfSelected = selectedCompetitors && selectedCompetitors?.length > 0 && selectedCompetitors?.find((prompt: any) => prompt?.competitor === item?.value)
                                    return (
                                        <div key={idx}
                                            // onClick={() => }
                                            className='flex md:flex-row items-center justify-between cursor-pointer hover:opacity-80 px-4 py-2 my-1 bg-white dark:bg-black rounded-lg'>
                                            <div className='flex flex-row items-center'>
                                                <img src={'/assets/chat/competitors.svg'} className='object-container w-[18px] mr-2' />
                                                <p className='dark:text-primary-dark text-md'>{item?.value}</p>
                                            </div>
                                            <div>
                                                <label className='flex items-center space-x-2 cursor-pointer'>
                                                    <input
                                                        type='radio'
                                                        name={`option-${idx}`}
                                                        value='Primary'
                                                        checked={findIfSelected?.type === 'primary'}
                                                        onClick={() => isNew && onClickOptions?.(item, data?.stage, 'primary')}
                                                        className='accent-green-600'
                                                    />
                                                    <span className='text-[#00330F] text-sm'>Primary</span>
                                                </label>
                                                <label className='flex items-center space-x-2 cursor-pointer'>
                                                    <input
                                                        type='radio'
                                                        name={`option-${idx}`}
                                                        value='Primary'
                                                        checked={findIfSelected?.type === 'secondary'}
                                                        onClick={() => isNew && onClickOptions?.(item, data?.stage, 'secondary')}
                                                        className='accent-green-600'
                                                    />
                                                    <span className='text-[#2D8EFF] text-sm'>Secondary</span>
                                                </label>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='my-3 flex flex-col md:flex-row md:item-center'>
                                <Input
                                    placeholder={'New Competitor'}
                                    inputValue={newBrand}
                                    showValue={true}
                                    disabled={!isNew}
                                    containerStyle='min-w-[30%]'
                                    inputUniqueName='brand'
                                    onChangeInput={onChangeBrand}
                                />
                                <SelectCheckbox
                                    placeholder='Type'
                                    selectedOption={newType ? CompetitorsType?.find((item: any) => item?.value === newType) : undefined}
                                    options={CompetitorsType}
                                    disabled={!isNew}
                                    containerStyle='mb-3 ml-4'
                                    uniqueName='type'
                                    onChangeSelectedOption={onChangeBrand}
                                />
                                <Button
                                    label={'Add Competitor'}
                                    className={`btn-border-rounded mb-3 ml-4 ${(newBrand && newType && isNew) ? '' : 'opacity-50'}`}
                                    onClickButton={() => (newBrand && newType && isNew) && onClickAddOptions?.(newBrand, 'competitors', newType)}
                                />
                            </div>
                            <div className='my-4 flex flex-row justify-end'>
                                <Button
                                    label={'Save'}
                                    className={`${(selectedCompetitors?.length > 0 && isNew) ? 'btn-primary-rounded-less !bg-[#00330F]' : 'btn-primary-rounded-less-disable opacity-70'} `}
                                    onClickButton={() => (selectedCompetitors?.length > 0 && isNew) && onClickSave?.(data?.stage)}
                                />
                            </div>
                        </>
                    }
                </div>
            }
            {(data?.stage === 'select_models_stage' && !isTyping) &&
                <div>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                        {models?.map((item: any, idx: number) => {
                            const findIfSelected =
                                selectedModels &&
                                selectedModels?.length > 0 &&
                                selectedModels?.find((prompt: any) => prompt?._id === item?._id);

                            const isDisabled = item?.enabled === false;

                            return (
                                <div
                                    key={idx}
                                    className={`relative flex md:flex-row items-center justify-between px-4 py-2 my-1 bg-white dark:bg-gray-500 rounded-lg ${isDisabled ? 'opacity-60 pointer-events-none' : 'cursor-pointer hover:opacity-80'}`}
                                >
                                    {(isDisabled || !isNew) && (
                                        <div className='absolute inset-0 bg-white/30 dark:bg-black/30 backdrop-blur-[0.5px] rounded-lg flex items-center justify-center'>                                        </div>
                                    )}

                                    <div className='flex flex-row items-center max-w-[85%]'>
                                        <img src={item?.logoUrl} className='w-[20px] object-contain mr-3' />
                                        <p className='dark:text-primary-dark'>{item?.name}</p>
                                    </div>

                                    <Switch
                                        checked={!!findIfSelected}
                                        onToggleSwitch={() => !isDisabled && isNew && onClickOptions?.(item, data?.stage)}
                                    />
                                </div>
                            );
                        })}
                    </div>
                    <div className='my-4 flex flex-row justify-end'>
                        <Button
                            label={'Save'}
                            className={`btn-primary-rounded-less ${(selectedModels?.length > 0 && isNew) ? '' : 'opacity-70'} !bg-[#00330F]`}
                            onClickButton={() => (selectedModels?.length > 0 && isNew) && onClickSave?.(data?.stage)}
                        />
                    </div>
                </div>
            }
            {(data?.stage === 'pricing' && !isTyping) &&
                <div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:items-stretch">
                        <div onClick={() => !pricingLoading && onClickPricing?.('price', data?.options?.find((item: any) => item?.plan === 'month'))} className="border border-1 rounded-xl bg-white py-3 px-4 cursor-pointer hover:opacity-80 hover:border-borderColor-default min-w-[250px] w-full h-full flex flex-col">
                            <div className="h-7"></div>
                            <p className="text-primary-default text-lg mb-2 font-medium text-center">Monthly Plan</p>
                            <p className="text-primary-default text-lg text-center">
                                <span className="!text-2xl font-bold">£{(data?.options?.find((item: any) => item?.plan === 'month')?.value || data?.options?.find((item: any) => item?.plan === 'month')?.total) || '--'}</span> /month
                            </p>
                            <p className="mt-2 text-center text-primary-default text-md">billed monthly</p>
                            <div className='border-t border-t-1 pt-2 mt-4 '>
                                <div className='w-[90%] bg-bgColor-default mx-auto py-2 px-3 text-white rounded-xl'>
                                    <p className='text-center'>Continue to Payment</p>
                                </div>
                            </div>
                        </div>

                        <div onClick={() => !pricingLoading && onClickPricing?.('price', data?.options?.find((item: any) => item?.plan === 'year'))} className="border border-1 rounded-xl bg-white py-3 px-4 cursor-pointer hover:opacity-80 hover:border-borderColor-default min-w-[250px] w-full h-full flex flex-col">
                            <div className="h-7">
                                <div className="flex flex-row justify-end items-center">
                                    <div className="rounded-lg bg-bgColor-default text-white px-3 py-1">
                                        <p className="text-xs text-white">Save {getYearlyDiscountPercent(data?.options || [])}%</p>
                                    </div>
                                </div>
                            </div>
                            <p className="text-primary-default text-lg mb-2 font-medium text-center">Annual Plan</p>
                            <p className="text-primary-default text-lg text-center">
                                <span className="!text-2xl font-bold">£{(data?.options?.find((item: any) => item?.plan === 'year')?.value || data?.options?.find((item: any) => item?.plan === 'year')?.total) || '--'}</span> /year
                            </p>
                            <p className="mt-2 text-center text-primary-default text-md">
                                equivalent to £{(data?.options?.find((item: any) => item?.plan === 'year')?.value  || data?.options?.find((item: any) => item?.plan === 'year')?.total)/ 12 || ''}/month
                            </p>
                            <div className='border-t border-t-1 pt-2 mt-4 '>
                                <div className='w-[90%] bg-bgColor-default mx-auto py-2 px-3 text-white rounded-xl'>
                                    <p className='text-center'>Continue to Payment</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="my-4 flex flex-col md:flex-row">
                        {/* <Button
                        label="Continue to Payment"
                        className="btn-primary-rounded-less !min-w-[200px] mb-3 !font-normal md:mb-0 md:mr-4"
                        onClickButton={() => onClickPricing?.('yes')}
                    /> */}
                        <Button
                            label="Let me speak to the team first"
                            className="btn-primary-rounded-less !min-w-[200px] !bg-white !border !border-1 !border-[#E9EAEB] !text-black !font-normal mb-3 md:mb-0"
                            onClickButton={() => (isNew && !pricingLoading) && onClickPricing?.('team')}
                        />
                    </div>
                </div>
            }
            {text && !isTyping && showActions && (
                <div className='mt-4 flex flex-row items-center'>
                    <div
                        onClick={() => {
                            const plainText = getPlainText(text);
                            navigator?.clipboard?.writeText(plainText);
                        }}
                        className='hover:opacity-80 cursor-pointer'>
                        <img
                            src={theme === 'dark' ? '/assets/chat/copy-icon-white.svg' : '/assets/chat/copy-icon.svg'}
                            className='object-contain h-[20px] mr-2'
                        />
                    </div>


                    {/* {data?._id && ( */}
                    {/*  <>
                            <div className='hover:opacity-80 cursor-pointer' onClick={() => onClickAction?.('like', data._id)}>
                                <img
                                    src={
                                        data?.liked
                                            ? theme === 'dark' ? '/assets/chat/like-selected-icon-white.svg' : '/assets/chat/like-selected-icon.svg'
                                            : theme === 'dark' ? '/assets/chat/like-icon-white.svg' : '/assets/chat/like-icon.svg'
                                    }
                                    className='object-contain h-[20px] mr-2'
                                />
                            </div>
                            <div className='hover:opacity-80 cursor-pointer' onClick={() => onClickAction?.('dislike', data._id)}>
                                <img
                                    src={
                                        data?.disliked
                                            ? theme === 'dark' ? '/assets/chat/dislike-selected-icon-white.svg' : '/assets/chat/dislike-selected-icon.svg'
                                            : theme === 'dark' ? '/assets/chat/dislike-icon-white.svg' : '/assets/chat/dislike-icon.svg'
                                    }
                                    className='object-contain h-[20px] mr-2'
                                />
                            </div>
                            <div className='hover:opacity-80 cursor-pointer' onClick={() => onClickAction?.('favorite', data._id)}>
                                <img
                                    src={
                                        data?.favorite
                                            ? theme === 'dark' ? '/assets/chat/favorite-selected-icon-white.svg' : '/assets/chat/favorite-selected-icon.svg'
                                            : theme === 'dark' ? '/assets/chat/favorite-icon-white.svg' : '/assets/chat/favorite-icon.svg'
                                    }
                                    className='object-contain h-[22px] mr-2'
                                />
                            </div>
                    </> 
                    */}

                    <div className='hover:opacity-80 cursor-pointer relative' onClick={handleClickSpeaking}>
                        <img
                            src={
                                isSpeaking
                                    ? theme === 'dark' && considerDarkMode
                                        ? '/assets/chat/audio-selected-icon-white.svg'
                                        : '/assets/chat/audio-selected-icon.svg'
                                    : theme === 'dark' && considerDarkMode
                                        ? '/assets/chat/audio-icon-white.svg'
                                        : '/assets/chat/audio-icon.svg'
                            }
                            className={`object-contain h-[20px] mr-2 ${isSpeaking ? 'animate-pulse' : ''}`}
                        />
                        {isSpeaking && (
                            <div className='absolute top-[-4px] right-[-4px] bg-[#252B37] dark:bg-gray-300 rounded-full w-2.5 h-2.5 animate-ping'></div>
                        )}
                    </div>
                </div>
            )}

        </div>
    );
};

export default AiMessages;